export default __webpack_public_path__ + "static/media/vision.6e5f4ac5.jpg";